import React, { useState } from "react"; 
import { db } from '../firebase/config';
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { collection, addDoc, getDoc, setDoc, updateDoc, doc } from "firebase/firestore";
import logo from "c:/sumasalto/src/asset/logoSumaSalto.png";
import Footer from "../asset/components/Footer";
import { useNavigate } from 'react-router-dom';
import { QRCodeCanvas } from "qrcode.react"; // 👈 agregado: QR

export default function Kiosco() {
  const [emailComercio, setEmailComercio] = useState("");
  const [passwordComercio, setPasswordComercio] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [comercioLogueado, setComercioLogueado] = useState(null);
  const [ValorPunto, setValorPunto] = useState(null);

  const [qrLink, setQrLink] = useState("");      // 👈 agregado: link del QR
  const [mostrarQR, setMostrarQR] = useState(false); // 👈 agregado: mostrar/ocultar modal QR

  const navigate = useNavigate();
  const auth = getAuth();

  // Generar link PWACliente 
  const generarLinkPWA = (ci) => {
    return `https://apisumauy.1montonx2.com/PWACliente/?id=${encodeURIComponent(ci)}`;
  };

  // Formularios
  const [alta, setAlta] = useState({ ci: "", nombre: "", email: "", monto: "", codigoCorto: "" });
  const [carga, setCarga] = useState({ ci: "", monto: "", codigoCorto: "" });

  // Login del comercio
  const loginComercio = async (e) => {
    e.preventDefault();
    setMensaje("");

    try {
      const cred = await signInWithEmailAndPassword(auth, emailComercio, passwordComercio);
      const uid = cred.user.uid;

      // Obtener datos del comercio
      const docRef = doc(db, "comercios", uid);
      const snap = await getDoc(docRef);

      if (snap.exists()) {
        const datos = snap.data();
        setComercioLogueado({ uid, ...datos });
        setValorPunto(datos.ValorPunto);
        setMensaje(`✅ Bienvenido ${datos.nombre}`);
      } else {
        setMensaje("❌ No se encontró información de este comercio.");
      }
    } catch (err) {
      console.error("❌ Error login comercio:", err);
      setMensaje("❌ Correo o clave incorrectos.");
    }
  };

  // --- Alta cliente con ci como ID ---
const altaCliente = async (e) => {
  e.preventDefault();
  if (!comercioLogueado) return setMensaje("⚠ Debe iniciar sesión el comercio");

  try {
    const puntos = Math.floor(Number(alta.monto) / ValorPunto);

    // Cliente con ID = ci
    const clienteRef = doc(db, "clientes", alta.ci.trim());
    const link = generarLinkPWA(alta.ci.trim());

    const nuevoCliente = {
      ci: alta.ci.trim(),
      nombre: alta.nombre,
      email: alta.email,
      puntos,
      comercioOrigen: comercioLogueado.nombre,
      codigoCorto: alta.codigoCorto,
      fechaRegistro: new Date().toISOString(),
      activo: true,
      linkPWA: link
    };

    // Guardar cliente en la BD
    await setDoc(clienteRef, nuevoCliente);

    // Guardar en cargas
    await addDoc(collection(db, "cargas"), {
      ciCliente: alta.ci.trim(),
      monto: Number(alta.monto),
      codigoCorto: alta.codigoCorto,
      uidComercio: comercioLogueado.uid,
      nombre: comercioLogueado.nombre,
      ValorPunto,
      puntos,
      fecha: new Date().toISOString()
    });

    // 👇 Mostrar QR inmediatamente
    setQrLink(link);
    setMostrarQR(true);

    // 👇 Enviar email al cliente
    try {
      const response = await fetch("https://apisumauy.1montonx2.com/sendMail.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" },
        body: new URLSearchParams({
          to: nuevoCliente.email,
          subject: "Bienvenido a SumaSalto 🎉",
          message: `Hola ${nuevoCliente.nombre}, gracias por unirte a SUMA. Aquí tienes el acceso a tu PWA Cliente. 
Puedes instalarla en tu celular para seguir tus puntos y beneficios. 

📱 En ANDROID: Abrí la app en tu navegador Chrome y seleccioná “Agregar a pantalla principal”.
🍏 En iOS: Abrí la app en Safari, tocá el ícono de compartir y luego seleccioná “Agregar a pantalla de inicio”`,
          link:link
        }),
      });

      const result = await response.text();
      console.log("📧 Respuesta del servidor:", result);
    } catch (mailError) {
      console.error("❌ Error al enviar el correo:", mailError);
    }

    setMensaje("✅ Cliente dado de alta con éxito");
    setAlta({ ci: "", nombre: "", email: "", monto: "", codigoCorto: "" });
  } catch (err) {
    console.error("❌ Error alta cliente:", err);
    setMensaje("❌ Error al dar de alta el cliente");
  }
};


  // --- Carga de monto con doc(ci) ---
  const cargaMonto = async (e) => {
    e.preventDefault();
    if (!comercioLogueado) return setMensaje("⚠ Debe iniciar sesión el comercio");

    try {
      const puntos = Math.floor(Number(carga.monto) / ValorPunto);
      const clienteRef = doc(db, "clientes", carga.ci.trim());
      const snap = await getDoc(clienteRef);

      if (snap.exists()) {
        const clienteData = snap.data();
        const puntosActuales = clienteData.puntos || 0;

        // 1️⃣ Actualizar puntos y codigoCorto
        await updateDoc(clienteRef, {
          puntos: puntosActuales + puntos,
          codigoCorto: carga.codigoCorto
        });

        // 2️⃣ Registrar en cargas
        await addDoc(collection(db, "cargas"), {
          ciCliente: carga.ci.trim(),
          monto: Number(carga.monto),
          codigoCorto: carga.codigoCorto,
          uidComercio: comercioLogueado.uid,
          nombre: comercioLogueado.nombre,
          ValorPunto,
          puntos,
          fecha: new Date().toISOString()
        });

        // 3️⃣ Registrar en auditorias
        await addDoc(collection(db, "auditorias"), {
          fechaAutomatica: new Date().toISOString(),
          codigoCorto: carga.codigoCorto,
          nombreComercio: comercioLogueado.nombre,
          uidComercio: comercioLogueado.uid,
          monto: Number(carga.monto),
          ciCliente: carga.ci.trim(),
          nombreCliente: clienteData.nombre || ""
        });

        setMensaje("✅ Carga de monto realizada con éxito");
        setCarga({ ci: "", monto: "", codigoCorto: "" });
      } else {
        setMensaje("⚠ Cliente no encontrado");
      }
    } catch (err) {
      console.error("❌ Error carga monto:", err);
      setMensaje("❌ Error al cargar el monto");
    }
  };

  return (
    <div className="p-4 flex flex-col min-h-screen">
      {/* Encabezado */}
      <header className="text-center mb-6">
        <img src={logo} alt="logo" className="mx-auto" style={{ height: "80px" }} />
        <h1 className="text-2xl font-bold">Bienvenido al sistema de puntos multi-comercios SumaSalto</h1>
      </header>

      {/* Mensajes */}
      {mensaje && <div className="mb-4 p-2 bg-yellow-100 border border-yellow-300">{mensaje}</div>}

      {/* Login comercio */}
      {!comercioLogueado && (
        <form onSubmit={loginComercio} className="mb-6 border p-4">
          <h2 className="font-bold mb-2">Login Comercio</h2>
          <input type="email" placeholder="Email" value={emailComercio} onChange={(e) => setEmailComercio(e.target.value)} className="border p-1 w-full mb-2" />
          <input type="password" placeholder="Contraseña" value={passwordComercio} onChange={(e) => setPasswordComercio(e.target.value)} className="border p-1 w-full mb-2" />
          <button className="bg-blue-500 text-white px-4 py-1 rounded">Ingresar</button>
        </form>
      )}

      {/* Instrucciones */}
      <section className="mb-6">
        <h2 className="font-bold mb-2">Instrucciones</h2>
        <ol className="list-decimal pl-6">
          <li>Darse de alta (completar el formulario).</li>
          <li>Recibe tu tarjeta de lealtad enviada por email o escanea el QR, sigue las instrucciones para instalarla.</li>
          <li>Cada vez que compres, carga los montos ingresando tu CI, monto y los ultimos 4 digitos de tu factura.</li>
        </ol>
      </section>

      {/* Formularios */}
      {comercioLogueado && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Alta */}
          <form onSubmit={altaCliente} className="border p-4">
            <h2 className="font-bold mb-2">Alta Cliente</h2>
            <input type="text" placeholder="CI" value={alta.ci} onChange={(e) => setAlta({ ...alta, ci: e.target.value })} className="border p-1 w-full mb-2" />
            <input type="text" placeholder="Nombre" value={alta.nombre} onChange={(e) => setAlta({ ...alta, nombre: e.target.value })} className="border p-1 w-full mb-2" />
            <input type="email" placeholder="Email" value={alta.email} onChange={(e) => setAlta({ ...alta, email: e.target.value })} className="border p-1 w-full mb-2" />
            <input type="number" placeholder="Monto inicial" value={alta.monto} onChange={(e) => setAlta({ ...alta, monto: e.target.value })} className="border p-1 w-full mb-2" />
            <input type="text" placeholder="Ultimos 4 digitos factura" value={alta.codigoCorto} onChange={(e) => setAlta({ ...alta, codigoCorto: e.target.value })} className="border p-1 w-full mb-2" />
            <button className="bg-green-500 text-white px-4 py-1 rounded">Dar de Alta</button>
          </form>

          {/* Carga */}
          <form onSubmit={cargaMonto} className="border p-4">
            <h2 className="font-bold mb-2">Carga de Monto</h2>
            <input type="text" placeholder="CI" value={carga.ci} onChange={(e) => setCarga({ ...carga, ci: e.target.value })} className="border p-1 w-full mb-2" />
            <input type="number" placeholder="Monto" value={carga.monto} onChange={(e) => setCarga({ ...carga, monto: e.target.value })} className="border p-1 w-full mb-2" />
            <input type="text" placeholder="Ultimos 4 digitos factura" value={carga.codigoCorto} onChange={(e) => setCarga({ ...carga, codigoCorto: e.target.value })} className="border p-1 w-full mb-2" />
            <button className="bg-blue-500 text-white px-4 py-1 rounded">Cargar Monto</button>
          </form>
        </div>
      )}

      {/* Modal QR - agregado */}
{mostrarQR && qrLink && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white p-6 rounded shadow-lg text-center">
      <h2 className="font-bold text-xl mb-4">📱 Escanea tu QR</h2>
      {/* ✅ corregido: usar qrLink en lugar de linkPWA */}
      <QRCodeCanvas value={qrLink} size={200} />

      <p className="mt-2 break-all">{qrLink}</p>
      <button
        className="mt-4 bg-red-500 text-white px-4 py-1 rounded"
        onClick={() => setMostrarQR(false)}
      >
        Cerrar
      </button>
    </div>
  </div>
)}


      <button
        onClick={() => navigate('/')}
        style={{
          marginTop: '20px',
          padding: '10px 20px',
          backgroundColor: '#1976d2',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          fontWeight: 'bold',
        }}
      >
        ← Volver al Inicio
      </button>

      {/* Footer */}
      <Footer />
    </div>
  );
}



